// import helper from './util/helper';
import fontAwesome from '../Scripts/modules/fontawesome/fontawesome.module';
import alpine from '../Scripts/modules/alpine/alpine.module';
import {
  mobileNavGoNext,
  mobileNavBackButton
} from '../Scripts/modules/mobile-menu/mobile-menu.module';
import { handleStickyHeader } from '../Scripts/modules/sticky/sticky.module';
import youTubePlayer from '../Scripts/modules/youtube/youtube.module';
import {
  contentSlider,
  relatedProductsSlider,
  logoSlider,
  quoteSlider,
  productOutlineSlider,
  heroSlider
} from '../Scripts/modules/swiper/swiper.module';
import GLightbox from 'glightbox/dist/js/glightbox';
import floatingLabels from '../Scripts/modules/forms/forms.module';

/* eslint-enable no-unused-vars */

// make sure Promise is present
// require('es6-promise/auto');

function init() {
  fontAwesome();
  alpine();
  GLightbox();

  // Mobile nav
  mobileNavGoNext();
  mobileNavBackButton();

  window.addEventListener('scroll', () => {
    handleStickyHeader();
  });

  // Init paging
  window.goToPage = function(el) {
    const item = document.getElementById(el.id);
    const selectedVal = item.options[item.selectedIndex];
    const url = selectedVal.getAttribute('data-url');
    if (url) {
      window.location = url;
    }
  };

  youTubePlayer();

  // Init swiper
  contentSlider();
  relatedProductsSlider();
  logoSlider();
  quoteSlider();
  productOutlineSlider();
  heroSlider();

  floatingLabels();

  // Form WILA location selection
  const contactForm = document.getElementById(
    'umbraco_form_df0715adae0c4573ae1a45ddaffe2424'
  );

  if (contactForm != null) {
    console.log('contactForm', contactForm);
    const wilaLocationField = document.getElementById(
      'd9617234-d773-4840-a7ed-1914640e1e28'
    );
    const currentCulture = window.currentCulture;
    const wilaLocations = window.wilaLocations;

    const wilaLocation = wilaLocations.find(location =>
      location.matchingCultures.includes(currentCulture)
    );

    wilaLocationField.value = wilaLocation.codeName;

    floatingLabels();
  }

  var gaEcomPurchase = sessionStorage.getItem('gaEcomPurchase');
  if (gaEcomPurchase) {
    var purchaseEvent = JSON.parse(gaEcomPurchase);
    window.gtag('event', 'purchase', purchaseEvent);
    sessionStorage.removeItem('gaEcomPurchase');
  }
}

export default {
  init
};
